import { BrowserRouter as Router, useLocation } from "react-router-dom";

// import Footer from "./common/components/footer";
import NavBar from "@/app/nav-bar";
import Notifications from "@/app/notifications";
import { AuthProvider } from "@/contexts/auth-context";
import { WorkoutsProvider } from "@/contexts/workouts-context";
import RouteManager from "@/app/routes";

// The landing page is a full-bleed marketing surface; every other route gets
// the padded app container.
function Shell({ children }: { children: React.ReactNode }) {
  const { pathname } = useLocation();
  if (pathname === "/") return <div className="flex-1 w-full overflow-auto">{children}</div>;
  return (
    <div className="flex h-full items-top justify-center lg:px-8 px-2 flex-1 w-full mx-auto overflow-auto">
      <div className="w-full h-full">{children}</div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <WorkoutsProvider>
        <Router>
          <div className="bg-surface-page h-full overflow-auto flex flex-col">
            <Notifications />
            <NavBar />
            <Shell>
              <RouteManager />
            </Shell>
            {/* <Footer /> */}
          </div>
        </Router>
      </WorkoutsProvider>
    </AuthProvider>
  );
}

export default App;
